var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 0C26.8196 0 17.5355 3.84557 10.6908 10.6908C3.84557 17.536 0 26.8199 0 36.5C0 46.1801 3.84557 55.4645 10.6908 62.3092C17.536 69.1544 26.8199 73 36.5 73C46.1801 73 55.4645 69.1544 62.3092 62.3092C69.1544 55.464 73 46.1801 73 36.5C73 26.8199 69.1544 17.5355 62.3092 10.6908C55.464 3.84557 46.1801 0 36.5 0ZM55.6019 27.2136L31.2683 51.5472C30.5072 52.3151 29.4704 52.7469 28.3889 52.7469C27.308 52.7469 26.2712 52.3151 25.5096 51.5472L13.3428 39.3804C12.3142 38.3518 11.9122 36.852 12.2891 35.4472C12.6659 34.0418 13.7631 32.944 15.1684 32.5679C16.5738 32.191 18.073 32.593 19.1016 33.6216L28.389 42.9497L49.8425 21.4545C50.8712 20.4259 52.371 20.0239 53.7764 20.4007C55.1811 20.7769 56.2789 21.8747 56.6558 23.2801C57.0319 24.6848 56.6306 26.1847 55.6013 27.2133L55.6019 27.2136Z",
    fill: "#82C1A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b5a3f56f96474a2f7ba47d6028632a40.svg";
export { ForwardRef as ReactComponent };